import {ColorName} from '../palettes/ColorName';
import {colorNameToVar} from '../palettes/colorNameToVar';

export const browserColorScheme = () => colorNameToVar[ColorName.BrowserColorScheme];
export const colorKeylineDefault = () => colorNameToVar[ColorName.KeylineDefault];
export const colorLinkDefault = () => colorNameToVar[ColorName.LinkDefault];
export const colorLinkHover = () => colorNameToVar[ColorName.LinkHover];
export const colorLinkDisabled = () => colorNameToVar[ColorName.LinkDisabled];
export const colorTextDefault = () => colorNameToVar[ColorName.TextDefault];
export const colorTextLight = () => colorNameToVar[ColorName.TextLight];
export const colorTextLighter = () => colorNameToVar[ColorName.TextLighter];
export const colorTextDisabled = () => colorNameToVar[ColorName.TextDisabled];
export const colorTextRed = () => colorNameToVar[ColorName.TextRed];
export const colorTextYellow = () => colorNameToVar[ColorName.TextYellow];
export const colorTextGreen = () => colorNameToVar[ColorName.TextGreen];
export const colorTextBlue = () => colorNameToVar[ColorName.TextBlue];
export const colorTextOlive = () => colorNameToVar[ColorName.TextOlive];
export const colorTextCyan = () => colorNameToVar[ColorName.TextCyan];
export const colorTextLime = () => colorNameToVar[ColorName.TextLime];
export const colorBackgroundDefault = () => colorNameToVar[ColorName.BackgroundDefault];
export const colorBackgroundDefaultHover = () => colorNameToVar[ColorName.BackgroundDefaultHover];
export const colorBackgroundLight = () => colorNameToVar[ColorName.BackgroundLight];
export const colorBackgroundLightHover = () => colorNameToVar[ColorName.BackgroundLightHover];
export const colorBackgroundLighter = () => colorNameToVar[ColorName.BackgroundLighter];
export const colorBackgroundLighterHover = () => colorNameToVar[ColorName.BackgroundLighterHover];
export const colorBackgroundDisabled = () => colorNameToVar[ColorName.BackgroundDisabled];
export const colorBackgroundRed = () => colorNameToVar[ColorName.BackgroundRed];
export const colorBackgroundRedHover = () => colorNameToVar[ColorName.BackgroundRedHover];
export const colorBackgroundYellow = () => colorNameToVar[ColorName.BackgroundYellow];
export const colorBackgroundYellowHover = () => colorNameToVar[ColorName.BackgroundYellowHover];
export const colorBackgroundGreen = () => colorNameToVar[ColorName.BackgroundGreen];
export const colorBackgroundGreenHover = () => colorNameToVar[ColorName.BackgroundGreenHover];
export const colorBackgroundBlue = () => colorNameToVar[ColorName.BackgroundBlue];
export const colorBackgroundBlueHover = () => colorNameToVar[ColorName.BackgroundBlueHover];
export const colorBackgroundOlive = () => colorNameToVar[ColorName.BackgroundOlive];
export const colorBackgroundOliverHover = () => colorNameToVar[ColorName.BackgroundOliverHover];
export const colorBackgroundCyan = () => colorNameToVar[ColorName.BackgroundCyan];
export const colorBackgroundCyanHover = () => colorNameToVar[ColorName.BackgroundCyanHover];
export const colorBackgroundLime = () => colorNameToVar[ColorName.BackgroundLime];
export const colorBackgroundLimeHover = () => colorNameToVar[ColorName.BackgroundLimeHover];
export const colorBackgroundGray = () => colorNameToVar[ColorName.BackgroundGray];
export const colorBackgroundGrayHover = () => colorNameToVar[ColorName.BackgroundGrayHover];
export const colorBorderDefault = () => colorNameToVar[ColorName.BorderDefault];
export const colorBorderHover = () => colorNameToVar[ColorName.BorderHover];
export const colorBorderDisabled = () => colorNameToVar[ColorName.BorderDisabled];
export const colorFocusRing = () => colorNameToVar[ColorName.FocusRing];
export const colorAccentPrimary = () => colorNameToVar[ColorName.AccentPrimary];
export const colorAccentPrimaryHover = () => colorNameToVar[ColorName.AccentPrimaryHover];
export const colorAccentReversed = () => colorNameToVar[ColorName.AccentReversed];
export const colorAccentReversedHover = () => colorNameToVar[ColorName.AccentReversedHover];
export const colorAccentRed = () => colorNameToVar[ColorName.AccentRed];
export const colorAccentRedHover = () => colorNameToVar[ColorName.AccentRedHover];
export const colorAccentYellow = () => colorNameToVar[ColorName.AccentYellow];
export const colorAccentYellowHover = () => colorNameToVar[ColorName.AccentYellowHover];
export const colorAccentGreen = () => colorNameToVar[ColorName.AccentGreen];
export const colorAccentGreenHover = () => colorNameToVar[ColorName.AccentGreenHover];
export const colorAccentBlue = () => colorNameToVar[ColorName.AccentBlue];
export const colorAccentBlueHover = () => colorNameToVar[ColorName.AccentBlueHover];
export const colorAccentCyan = () => colorNameToVar[ColorName.AccentCyan];
export const colorAccentCyanHover = () => colorNameToVar[ColorName.AccentCyanHover];
export const colorAccentLime = () => colorNameToVar[ColorName.AccentLime];
export const colorAccentLimeHover = () => colorNameToVar[ColorName.AccentLimeHover];
export const colorAccentLavender = () => colorNameToVar[ColorName.AccentLavender];
export const colorAccentLavenderHover = () => colorNameToVar[ColorName.AccentLavenderHover];
export const colorAccentOlive = () => colorNameToVar[ColorName.AccentOlive];
export const colorAccentOliveHover = () => colorNameToVar[ColorName.AccentOliveHover];
export const colorAccentGray = () => colorNameToVar[ColorName.AccentGray];
export const colorAccentGrayHover = () => colorNameToVar[ColorName.AccentGrayHover];
export const colorAccentWhite = () => colorNameToVar[ColorName.AccentWhite];
export const colorAlwaysWhite = () => colorNameToVar[ColorName.AlwaysWhite];
export const colorDialogBackground = () => colorNameToVar[ColorName.DialogBackground];
export const colorTooltipBackground = () => colorNameToVar[ColorName.TooltipBackground];
export const colorTooltipText = () => colorNameToVar[ColorName.TooltipText];
export const colorPopoverBackground = () => colorNameToVar[ColorName.PopoverBackground];
export const colorPopoverBackgroundHover = () => colorNameToVar[ColorName.PopoverBackgroundHover];
export const colorShadowDefault = () => colorNameToVar[ColorName.ShadowDefault];
export const colorCheckboxUnchecked = () => colorNameToVar[ColorName.CheckboxUnchecked];
export const colorCheckboxChecked = () => colorNameToVar[ColorName.CheckboxChecked];
export const colorCheckboxDisabled = () => colorNameToVar[ColorName.CheckboxDisabled];

// NAV COLORS
export const colorNavBackground = () => colorNameToVar[ColorName.NavBackground];
export const colorNavText = () => colorNameToVar[ColorName.NavText];
export const colorNavTextHover = () => colorNameToVar[ColorName.NavTextHover];
export const colorNavTextSelected = () => colorNameToVar[ColorName.NavTextSelected];
export const colorNavButton = () => colorNameToVar[ColorName.NavButton];
export const colorNavButtonHover = () => colorNameToVar[ColorName.NavButtonHover];

// LINEAGE GRAPH COLORS
export const colorLineageEdge = () => colorNameToVar[ColorName.LineageEdge];
export const colorLineageEdgeHighlighted = () => colorNameToVar[ColorName.LineageEdgeHighlighted];

// GRAPH GROUPS
export const colorLineageGroupNodeBackground = () =>
  colorNameToVar[ColorName.LineageGroupNodeBackground];
export const colorLineageGroupNodeBackgroundHover = () =>
  colorNameToVar[ColorName.LineageGroupNodeBackgroundHover];
export const colorLineageGroupNodeBorder = () => colorNameToVar[ColorName.LineageGroupNodeBorder];
export const colorLineageGroupNodeBorderHover = () =>
  colorNameToVar[ColorName.LineageGroupNodeBorderHover];
export const colorLineageGroupBackground = () => colorNameToVar[ColorName.LineageGroupBackground];

// GRAPH NODES
export const colorLineageNodeBackground = () => colorNameToVar[ColorName.LineageNodeBackground];
export const colorLineageNodeBackgroundHover = () =>
  colorNameToVar[ColorName.LineageNodeBackgroundHover];
export const colorLineageNodeBorder = () => colorNameToVar[ColorName.LineageNodeBorder];
export const colorLineageNodeBorderHover = () => colorNameToVar[ColorName.LineageNodeBorderHover];
export const colorLineageNodeBorderSelected = () =>
  colorNameToVar[ColorName.LineageNodeBorderSelected];

// Dataviz
export const colorDataVizBlue = () => colorNameToVar[ColorName.DataVizBlue];
export const colorDataVizBlueAlt = () => colorNameToVar[ColorName.DataVizBlueAlt];
export const colorDataVizBlurple = () => colorNameToVar[ColorName.DataVizBlurple];
export const colorDataVizBlurpleAlt = () => colorNameToVar[ColorName.DataVizBlurpleAlt];
export const colorDataVizBrown = () => colorNameToVar[ColorName.DataVizBrown];
export const colorDataVizBrownAlt = () => colorNameToVar[ColorName.DataVizBrownAlt];
export const colorDataVizCyan = () => colorNameToVar[ColorName.DataVizCyan];
export const colorDataVizCyanAlt = () => colorNameToVar[ColorName.DataVizCyanAlt];
export const colorDataVizGray = () => colorNameToVar[ColorName.DataVizGray];
export const colorDataVizGrayAlt = () => colorNameToVar[ColorName.DataVizGrayAlt];
export const colorDataVizGreen = () => colorNameToVar[ColorName.DataVizGreen];
export const colorDataVizGreenAlt = () => colorNameToVar[ColorName.DataVizGreenAlt];
export const colorDataVizLime = () => colorNameToVar[ColorName.DataVizLime];
export const colorDataVizLimeAlt = () => colorNameToVar[ColorName.DataVizLimeAlt];
export const colorDataVizOrange = () => colorNameToVar[ColorName.DataVizOrange];
export const colorDataVizOrangeAlt = () => colorNameToVar[ColorName.DataVizOrangeAlt];
export const colorDataVizPink = () => colorNameToVar[ColorName.DataVizPink];
export const colorDataVizPinkAlt = () => colorNameToVar[ColorName.DataVizPinkAlt];
export const colorDataVizRed = () => colorNameToVar[ColorName.DataVizRed];
export const colorDataVizRedAlt = () => colorNameToVar[ColorName.DataVizRedAlt];
export const colorDataVizTeal = () => colorNameToVar[ColorName.DataVizTeal];
export const colorDataVizTealAlt = () => colorNameToVar[ColorName.DataVizTealAlt];
export const colorDataVizViolet = () => colorNameToVar[ColorName.DataVizViolet];
export const colorDataVizVioletAlt = () => colorNameToVar[ColorName.DataVizVioletAlt];
export const colorDataVizYellow = () => colorNameToVar[ColorName.DataVizYellow];
export const colorDataVizYellowAlt = () => colorNameToVar[ColorName.DataVizYellowAlt];
export const colorBlueGradient = () => colorNameToVar[ColorName.BlueGradient];
